import React, {useState} from "react";
import * as prosConnect from "../prodect/ProsConnect";
import ImageWithMarker from "../components/ImageWithMarker";
import "./assets/scss/SelectLocationPictures.scss";
import {ATTR_OBJ_ID, ATTR_FILE_NAME, ATTR_PICT_ZOOM} from "../prodect/ProsConnect";
import UiImage from "../components/UiImage";
import prosAppNotif from "../prodect/ProsAppNotif";

export default function SelectLocationPictures(props){

    let locationPictures = prosConnect.getActiveProject().getLocationPictures(false)
    const [selectedImage, setSelectedImage] = useState()
    const [markerPos, setMarkerPos] = useState()

    function selectItem(item){
        if(!selectedImage) prosAppNotif('Halutessasi aseta sijaintimerkki ja tallenna.')
        if(selectedImage === item){
            setSelectedImage()
        } else {
            setSelectedImage(item)
        }
    }

    function markerChanged(marker) {
        setMarkerPos(marker)
    }

    function saveLocationObject(){
        props.addLocationPicture(selectedImage[ATTR_FILE_NAME], markerPos, selectedImage[ATTR_PICT_ZOOM]);
    }

    function renderLocationPictures(){
        const imgList = locationPictures.map((img, i) => {
            let isSelected = selectedImage && selectedImage[ATTR_OBJ_ID] === img[ATTR_OBJ_ID]
            return <li
                    key={'rlp__' + i}
                    className={ isSelected ? 'item-selected' : ''}
                    onClick={(evt)=> {
                        evt.preventDefault()
                        selectItem(img)
                    }}
                >
                <UiImage
                    imageId={"loc-thumpnail-" + img[ATTR_OBJ_ID]}
                    imageSrc={prosConnect.getItemThumpPath(img)}
                    alt={"Sijaintikuva"}
                    onImageClick={()=>{
                        selectItem(img)
                    }}
                />
                {(img.ui_caption ? <p>{img.ui_caption}</p> : '')}
                {isSelected ? <i className="ui-icon ui-icon_color-main ui-icon-check" /> : null}
            </li>
        })
        return <ul id="selectLocationPicturesList" className={"scrollpane-vertical"}>
            {locationPictures.length > 0 ? imgList : <p>Ei sijaintikuvia.</p>}
        </ul>
    }

    function renderImageViewer(){
        return selectedImage ? <ImageWithMarker
                key={'slp-iwm__' + selectedImage.obj_id}
                item={selectedImage}
                initialEditMode={true}
                isMarkerPlacingEnabled={true}
                listenMarkerChanges={marker => markerChanged(marker)}
                onSave={saveLocationObject}
                onCancel={props.close}
            /> : <p>Esikatselu</p>
    }

    return <>
        <section id="selectLocationPictures">
            <div>
                {renderLocationPictures()}
            </div>
            <div>
                <div id="imageViewer" className={"box-media box-media-full"}>
                    {renderImageViewer()}
                </div>
                {selectedImage ? <p className={"margin-0 padding-top"}>{selectedImage.ui_caption}</p> : ''}
            </div>
        </section>
    </>
}